import API from '../../../../helpers/request/api';

const api = () => new API();

const create = (userPostId) => {
  const query = {
    query: `mutation createUserPostHit {
      createUserPostHit(input: {
        user_post_id: ${userPostId}
      })
      {
        user_post_hit {
          id
        }
        message
      }
    }`,
  };

  return api().get(query);
};

const update = (userPostHitId) => {
  const query = {
    query: `mutation updateUserPostHit {
      updateUserPostHit(
        input: {
          id: ${userPostHitId}
        }
      )
      {
        message
      }
    }`,
  };

  return api().get(query);
};

export default {
  create,
  update,
};



// WEBPACK FOOTER //
// ./src/screens/Class/Index/queries/userPostHit.js